import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=58956647"
import script from "./TextBox.vue?vue&type=script&lang=js"
export * from "./TextBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports